import React from "react";
import Skeleton from "react-loading-skeleton"; // Assurez-vous d'importer Skeleton
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchSearchResults,
  setSearchParams,
  updateSearchField,
} from "./../store/slices/searchSlice";

const ServiceDispo = ({ services, status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCategorySet = (subCategory) => {
    // Mettre à jour la valeur de `query` avec le nom de la sous-catégorie
    // dispatch(updateSearchField({ field: 'query', value: subCategory.name }));

    // Mettre à jour la valeur de `categoryId` avec l'ID de la sous-catégorie
    // dispatch(updateSearchField({ field: 'categoryId', value: subCategory.id }));
    const searchData = {
      categoryId: subCategory.id || null,
      filtre: [],
      disponibilite: "all-time",
      when: "all_time",
      sortBy: "relevance",
      search_query: subCategory.name,
      query: subCategory.name,
    };

    dispatch(setSearchParams(searchData));
    dispatch(fetchSearchResults(searchData));

    navigate("/resultats", { replace: true });
  };

  // Affichage du Skeleton pendant le chargement
  if (status === "loading") {
    return (
      <div className="container space-bloc">
        <Skeleton
          count={1}
          height={50}
          width="50%"
          style={{ marginBottom: "10px" }}
        />
        <Skeleton
          count={2}
          height={20}
          width="80%"
          style={{ marginBottom: "20px" }}
        />
        <div className="row-custom-grid">
          {Array(5)
            .fill(0)
            .map((_, index) => (
              <div key={index} className="category-card">
                <Skeleton height={150} width="100%" />
                <Skeleton
                  height={20}
                  width="60%"
                  style={{ marginTop: "10px" }}
                />
              </div>
            ))}
        </div>
      </div>
    );
  }

  // Si les services existent et contiennent les données attendues
  if (services && services.title && services.description) {
    return (
      <div className="container space-bloc">
        <h2 className="grey600 mb-0">{services.title}</h2>
        <div className="row bottom-align justify-content-between align-items-end">
          <div className="col-md-6">
            <p className="mt-16 body grey66 mb-0">{services.description}</p>
          </div>
          <div className="col-md-6 cta-blue align-right text-end mt-xs-8">
            <Link to="/category" className="link-blue cta">
              Voir tous les types de services{" "}
              <img
                src="/images/arrow-right.svg"
                className="arrow ml-8"
                alt="Arrow"
              />
            </Link>
          </div>
        </div>

        {/* Grid des catégories */}
        <div className="row-custom-grid mt-32">
          {services.categories && services.categories.length > 0 ? (
            services.categories.map((category, index) => (
              <div
                key={category.id || index}
                className="category-card"
                onClick={() => handleCategorySet(category)}
              >
                <div className="catImg">
                  <img
                    src={`${process.env.REACT_APP_FILE_URL}/${category.image}`}
                    alt={category.name}
                  />
                </div>
                <h6 className="grey500 bold600 mr-8">
                  {category.name}{" "}
                  <img
                    src="/images/arrow-right-dark.svg"
                    className="arrow"
                    alt="Arrow"
                  />
                </h6>
              </div>
            ))
          ) : (
            <p>Aucune catégorie disponible pour le moment.</p>
          )}
        </div>
      </div>
    );
  }

  // Si les services n'existent pas ou sont vides
  return null;
};

export default ServiceDispo;
